/* eslint-disable react/destructuring-assignment */

import PropTypes from "prop-types";
import React from "react";

const Spinner = props => (
  <img
    alt="Loading"
    className={`spinner-component ${props.className}`}
    id={props.id}
    src="https://karat-herokuapp-com.freetls.fastly.net/s3media/site/wish_list/loading-jewelry-sparkle.gif"
  />
);

Spinner.propTypes = {
  "className": PropTypes.string,
  "id": PropTypes.string
};

Spinner.defaultProps = {
  "className": "",
  "id": ""
};

export default Spinner;
